module.exports = __webpack_public_path__ + "static/media/resources-header-image.72626dad.png";